import {
	START_FETCH_CONVERSATION,
	FETCH_CONVERSATION_SUCCESS,
	FETCH_CONVERSATION_FAILED,

	START_CREATE_CONVERSATION,
	CREATE_CONVERSATION_SUCCESS,
	CREATE_CONVERSATION_FAILED,

	START_CREATE_NORMAL_REPLY_CONVERSATION,
	CREATE_NORMAL_REPLY_CONVERSATION_SUCCESS,
	CREATE_NORMAL_REPLY_CONVERSATION_FAILED,

	START_CREATE_QUICK_PATH_CONVERSATION,
	CREATE_QUICK_PATH_CONVERSATION_SUCCESS,
	CREATE_QUICK_PATH_CONVERSATION_FAILED,

	START_CREATE_SMART_REPLY_CONVERSATION,
	CREATE_SMART_REPLY_CONVERSATION_SUCCESS,
	CREATE_SMART_REPLY_CONVERSATION_FAILED,

	START_UPDATE_CONVERSATION_TEXT_SIZE,
	UPDATE_CONVERSATION_TEXT_SIZE_SUCCESS,
	UPDATE_CONVERSATION_TEXT_SIZE_FAILED,

	START_CLOSE_CONVERSATION,
	CLOSE_CONVERSATION_SUCCESS,
	CLOSE_CONVERSATION_FAILED,

	START_GRADE_CONVERSATION_SCORE,
	GRADE_CONVERSATION_SCORE_SUCCESS,
	GRADE_CONVERSATION_SCORE_FAILED,

	START_CLEAR_CONVERSATION_SESSION,
	CLEAR_CONVERSATION_SESSION_SUCCESS,
	CLEAR_CONVERSATION_SESSION_FAILED,

	CLEARED_CONVERSATION_SESSION_EVENT,

	UPDATE_CONVERSATION_STATUS,

	UPDATE_CONVERSATION_COLOR_MAPPING,

	UPDATE_CONVERSATION_TEXT_SIZE_EVENT,

	RESET_CONVERSATION,

	UPDATE_CONVERSATION,
} from './action-types';

export function fetchConversationAction() {
	return {
		type: START_FETCH_CONVERSATION,
	};
}

export function fetchConversationSuccessAction(conversation) {
	return {
		type: FETCH_CONVERSATION_SUCCESS,
		conversation,
	};
}

export function fetchConversationFailedAction(error, errorMessage) {
	return {
		type: FETCH_CONVERSATION_FAILED,
		error,
		errorMessage,
	};
}

export function createConversationAction(type) {
	return {
		type: START_CREATE_CONVERSATION,
		conversationType: type,
	};
}

export function createConversationSuccessAction(conversationId) {
	return {
		type: CREATE_CONVERSATION_SUCCESS,
		conversationId,
	};
}

export function createConversationFailedAction(error, errorMessage) {
	return {
		type: CREATE_CONVERSATION_FAILED,
		error,
		errorMessage,
	};
}

export function createNormalReplyConversationAction() {
	return {
		type: START_CREATE_NORMAL_REPLY_CONVERSATION,
	};
}

export function createNormalReplyConversationSuccessAction(conversation) {
	return {
		type: CREATE_NORMAL_REPLY_CONVERSATION_SUCCESS,
		conversation,
	};
}

export function createNormalReplyConversationFailedAction(error, errorMessage) {
	return {
		type: CREATE_NORMAL_REPLY_CONVERSATION_FAILED,
		error,
		errorMessage,
	};
}

export function createQuickPathConversationAction() {
	return {
		type: START_CREATE_QUICK_PATH_CONVERSATION,
	};
}

export function createQuickPathConversationSuccessAction(conversation) {
	return {
		type: CREATE_QUICK_PATH_CONVERSATION_SUCCESS,
		conversation,
	};
}

export function createQuickPathConversationFailedAction(error, errorMessage) {
	return {
		type: CREATE_QUICK_PATH_CONVERSATION_FAILED,
		error,
		errorMessage,
	};
}

export function createSmartReplyConversationAction() {
	return {
		type: START_CREATE_SMART_REPLY_CONVERSATION,
	};
}

export function createSmartReplyConversationSuccessAction(conversation) {
	return {
		type: CREATE_SMART_REPLY_CONVERSATION_SUCCESS,
		conversation,
	};
}

export function createSmartReplyConversationFailedAction(error, errorMessage) {
	return {
		type: CREATE_SMART_REPLY_CONVERSATION_FAILED,
		error,
		errorMessage,
	};
}

export function updateConversationTextSizeAction(textSize) {
	return {
		type: START_UPDATE_CONVERSATION_TEXT_SIZE,
		textSize,
	};
}

export function updateConversationTextSizeSuccessAction(conversation) {
	return {
		type: UPDATE_CONVERSATION_TEXT_SIZE_SUCCESS,
		conversation,
	};
}

export function updateConversationTextSizeFailedAction(error, errorMessage) {
	return {
		type: UPDATE_CONVERSATION_TEXT_SIZE_FAILED,
		error,
		errorMessage,
	};
}

export function closeConversationAction(isNavigatingHome = false) {
	return {
		type: START_CLOSE_CONVERSATION,
		isNavigatingHome,
	};
}

export function closeConversationSuccessAction(conversation) {
	return {
		type: CLOSE_CONVERSATION_SUCCESS,
		conversation,
	};
}

export function closeConversationFailedAction(error, errorMessage) {
	return {
		type: CLOSE_CONVERSATION_FAILED,
		error,
		errorMessage,
	};
}

export function gradeConversationScoreAction(score) {
	return {
		type: START_GRADE_CONVERSATION_SCORE,
		score,
	};
}

export function gradeConversationScoreSuccessAction(score, scoreAt) {
	return {
		type: GRADE_CONVERSATION_SCORE_SUCCESS,
		score,
		scoreAt,
	};
}

export function gradeConversationScoreFailedAction(error, errorMessage) {
	return {
		type: GRADE_CONVERSATION_SCORE_FAILED,
		error,
		errorMessage,
	};
}

export function clearConversationSessionAction() {
	return {
		type: START_CLEAR_CONVERSATION_SESSION,
	};
}

export function clearConversationSessionSuccessAction() {
	return {
		type: CLEAR_CONVERSATION_SESSION_SUCCESS,
	};
}

export function clearConversationSessionFailedAction(error, errorMessage) {
	return {
		type: CLEAR_CONVERSATION_SESSION_FAILED,
		error,
		errorMessage,
	};
}

export function clearConversationSessionEventAction(platformId, conversationid) {
	return {
		type: CLEARED_CONVERSATION_SESSION_EVENT,
		platformId,
		conversationid,
	};
}

export function updateConversationStatusAction(conversation) {
	return {
		type: UPDATE_CONVERSATION_STATUS,
		conversation,
	};
}

export function updateConversationColorMappingAction(data) {
	return {
		type: UPDATE_CONVERSATION_COLOR_MAPPING,
		data,
	};
}

export function updateConversationTextSizeEventAction(conversation) {
	return {
		type: UPDATE_CONVERSATION_TEXT_SIZE_EVENT,
		conversation,
	};
}

export function resetConversationAction() {
	return {
		type: RESET_CONVERSATION,
	};
}

export function updateConversationAction(conversation) {
	return {
		type: UPDATE_CONVERSATION,
		conversation,
	};
}
